// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3xUo3","balanceDisclaimer":"posDashboard_balanceDisclaimer__38xV9"};